Auth = require 'db/auth'
ClientConfig = require 'debug/client-config'
{ ldclient } = require 'common/lib/ldclient'
moment = require('moment')
NoticeBanner = require('common/components/notice-banner/notice-banner').default
{ boardLimitsGracePeriodEndDate } = require 'common/data/rollout-dates'
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_limits')
trackUe = require 'debug/trackUe'
_ = require 'underscore'

isDesktop = ClientConfig.get('appId') == 'desktop'
learnMoreUrl = 'https://help.trello.com/article/1177-personal-vs-team-boards'

module.exports = class BoardLimitsGracePeriodBanner extends React.Component
  displayName: 'BoardLimitsGracePeriodBanner'

  constructor: (props) ->
    super props
    @state =
      boardLimitsGracePeriodFlag: ldclient.variation('bc.board_limits_grace_period', false)
      boardLimitsCloseToEndOfGracePeriodFlag: ldclient.variation('bc.board_limits_close_to_end_of_grace_period', false)
      bannerDismissed: false

    @onLdUpdateGracePeriod = @onLdUpdateGracePeriod.bind(@)
    @onLdUpdateCloseToEndOfGracePeriod = @onLdUpdateCloseToEndOfGracePeriod.bind(@)

    if @props.model?.typeName == 'Board'
      @org = @props.model.getOrganization()
    else if @props.model?.typeName == 'Member'
      # If user is on a member page, we want the first org they are a member of that has been grandparented
      # into the grace period (i.e they have a board limit override)
      @org = _.find(@props.model.organizationList.models, (org) -> org.isFreeBoardLimitOverridden())
    else
      @org = null

    if @org
      @gracePeriodEndDate = moment(boardLimitsGracePeriodEndDate)

  onLdUpdateGracePeriod: (newVal) ->
    @setState
      boardLimitsGracePeriodFlag: newVal

  onLdUpdateCloseToEndOfGracePeriod: (newVal) ->
    @setState
      boardLimitsCloseToEndOfGracePeriodFlag: newVal

  componentDidMount: ->
    ldclient.on 'change:bc.board_limits_grace_period', @onLdUpdateGracePeriod
    ldclient.on 'change:bc.board_limits_close_to_end_of_grace_period', @onLdUpdateCloseToEndOfGracePeriod

  componentWillUnmount: ->
    ldclient.off 'change:bc.board_limits_grace_period', @onLdUpdateGracePeriod
    ldclient.off 'change:bc.board_limits_close_to_end_of_grace_period', @onLdUpdateCloseToEndOfGracePeriod

  dismissGracePeriodBanner: (bannerId) =>
    dirObj = 'board limits grace period banner'
    indObj = 'on #{@props.model?.typeName}'
    method = 'by clicking dismiss in banner'
    Auth.me().dismiss(bannerId)
    @setState
      bannerDismissed: true

    trackUe(@props.context, 'dismisses', dirObj, '', indObj, method, { teamId: @org?.id })

  render: t.renderable ->
    t.div =>
      now = moment()
      # Only show the banner to non-desktop users who were part of an org grandparented into
      # free board limits (i.e their limit is overridden)
      if @state.bannerDismissed ||
        isDesktop ||
        now.isSameOrAfter(@gracePeriodEndDate) ||
        !@org ||
        !@org?.isFreeBoardLimitOverridden()
          return

      if !Auth.me().isDismissed('BoardLimitsGracePeriod') &&
        @state.boardLimitsGracePeriodFlag &&
        !@state.boardLimitsCloseToEndOfGracePeriodFlag
          t.div '.board-limits-grace-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissGracePeriodBanner.bind(@, 'BoardLimitsGracePeriod')
              learnMoreUrl
            }, =>
              t.format 'beginning-of-grace-period',
                gracePeriodEndDate: @gracePeriodEndDate.format('LL')

      if !Auth.me().isDismissed('BoardLimitsCloseToEndOfGracePeriod') &&
        @state.boardLimitsCloseToEndOfGracePeriodFlag
          t.div '.board-limits-grace-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissGracePeriodBanner.bind(@, 'BoardLimitsCloseToEndOfGracePeriod')
              learnMoreUrl
            }, =>
              t.format 'close-to-end-of-grace-period',
                gracePeriodEndDate: @gracePeriodEndDate.format('LL')



// WEBPACK FOOTER //
// ./app/scripts/views/board-limits/grace-period-banner.coffee